// extracted by mini-css-extract-plugin
export var label = "_5u-5";
export var slideContainer = "_5u-0";
export var slider = "_5u-1";
export var sliderLg = "_5u-4";
export var sliderMd = "_5u-3";
export var sliderSm = "_5u-2";